module.exports = __webpack_public_path__ + "img/oneday1-1.97ecd6a9.jpg";